export  const getFieldsArrayByRowSelection = (data, rowSelection, field) => {
    return data.reduce((acc, el) => {
        if (rowSelection.includes(el.id)) {
            acc.push(el[field]);
        }
        return acc;
    }, [])
}

export const normalizeSelection = (rowSelection) => rowSelection ? rowSelection?.reduce(
    (acc, id) => {
        acc[id] = true

        return acc;
    },
    {}
) : {}

const selectionTableUtil = (data, setRowSelection) => {
    const onRowSelectionChange = (updater) => {
        setRowSelection((old) => {
            const result = Object.fromEntries(Object.entries(updater(normalizeSelection(old))).filter(([key, value]) => Number.isInteger(+key)))
            const currentSelectedIds = Object.entries(result)
                .filter(([_, value]) => value)
                .map(([index]) => +index)

            const currentPageIds = data.map(({id}) => id)
            const allSelectedWithoutCurrentPage = old.filter((it) => !currentPageIds.includes(it))
            const newOne = Array.from(new Set([...allSelectedWithoutCurrentPage, ...currentSelectedIds]));

            return newOne
        })
    }
    return {onRowSelectionChange}
}

export default selectionTableUtil

